import { Download } from "lucide-react";
import { type ReactElement } from "react";

import { HubBlobUrlPreview } from "@/components/HubBlobUrlPreview";
import { Button } from "@/components/ui/Button";
import { DocumentModal } from "@/pages/documents/DocumentModal";

export function HubAttachmentPreviewModal({
  filename,
  contentType,
  previewUrl,
  isLoading = false,
  error = null,
  onClose,
  onDownload,
}: {
  filename: string;
  contentType?: string | null;
  previewUrl: string | null;
  isLoading?: boolean;
  error?: string | null;
  onClose: () => void;
  onDownload: () => void;
}): ReactElement {
  return (
    <DocumentModal
      title={filename}
      onClose={onClose}
      shellClassName="max-w-[min(96vw,90rem)] min-h-[min(92vh,56rem)]"
      mainClassName="min-h-0 flex-1 px-4 py-4"
      titleTrailing={
        <Button type="button" size="sm" variant="secondary" onClick={onDownload} disabled={previewUrl == null}>
          <Download className="mr-1.5 h-4 w-4" aria-hidden />
          Download
        </Button>
      }
    >
      {isLoading ? (
        <p className="py-12 text-center text-sm text-slate-500">Loading preview…</p>
      ) : error != null ? (
        <p className="px-3 py-8 text-center text-sm text-red-700">{error}</p>
      ) : previewUrl != null ? (
        <HubBlobUrlPreview
          previewUrl={previewUrl}
          filename={filename}
          contentType={contentType}
          fillAvailableHeight
        />
      ) : (
        <p className="py-10 text-center text-sm text-slate-600">Preview is not available.</p>
      )}
    </DocumentModal>
  );
}
